import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { MainAppState, ManageUserAppState } from "../appState/models";

export const manageUserSelector = createDraftSafeSelector(
  (state: MainAppState) => state,
  (state: MainAppState) => state.manageUser.manageUser,
);

// Selector for user detail
export const createUserDataSelector = createDraftSafeSelector(
  manageUserSelector,
  (state: ManageUserAppState) => state.createUserDetail,
);

export const manageUserRoleListSelector = createDraftSafeSelector(
  manageUserSelector,
  (state: ManageUserAppState) => state.userRoleList,
);

export const storedEditReportListSelector = createDraftSafeSelector(
  manageUserSelector,
  (state: ManageUserAppState) => state.addedReports,
);
